// 第1张
const imgAllA = {
    JP: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724663204271/c3.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724663204086/d3.jpg',
    },
    NA: {
        pc: '',
        h5: '',
    },
    EU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725155341023/euPC3.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725155340666/euH3.jpg',
    },
    UK: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725162852278/ukPC3.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725162852459/ukH3.jpg',
    },
    AU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1736750480442/BMS.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1736905844310/BMS.jpg',
    },
};
const imgLocale: any = {
    jp: imgAllA.JP,
    us: imgAllA.JP,
    ca: imgAllA.JP,
    uk: imgAllA.UK,
    eu: imgAllA.EU,
    de: imgAllA.EU,
    fr: imgAllA.EU,
    it: imgAllA.EU,
    es: imgAllA.EU,
    au: imgAllA.AU,
};
export default imgLocale;
